import { getSavedEnums } from "../../../../../services/authService";
import insuranceCalcKobstederne from "./insuranceCalcKoebstederne";
import insuranceCalcTryg from "./insuranceCalcTryg";
import { InsuranceCalcMethodType } from "./insuranceCalcTypes";

const insuranceCalc: InsuranceCalcMethodType = (...args) => {
  const trygSource = getSavedEnums()?.leasingCase?.insuranceSource?.find(item => item.title === 'Tryg')
  if (args[0].insuranceInput.source === trygSource?.id) {
    return insuranceCalcTryg(...args)
  }
  return insuranceCalcKobstederne(...args)
};

export default insuranceCalc;
